document.addEventListener("DOMContentLoaded", function () {
  const faqs = document.querySelectorAll(".accordion__faq");

  faqs.forEach((faq) => {
    const question = faq.querySelector(".accordion__question");
    const answer = faq.querySelector(".accordion__answer");

    if (question && answer) {
      question.addEventListener("click", function () {
        const isActive = faq.classList.contains("active");

        faqs.forEach((faqItem) => {
          if (faqItem !== faq) {
            faqItem.classList.remove("active");
            const otherAnswer = faqItem.querySelector(".accordion__answer");
            if (otherAnswer) otherAnswer.style.maxHeight = null;
          }
        });

        faq.classList.toggle("active", !isActive);
        answer.style.maxHeight = isActive ? null : answer.scrollHeight + "px";
      });
    }
  });
});
